







import Vue from 'vue'
import MapContainer from './components/MapContainer.vue'
import FilterContainer from './components/FilterContainer.vue'

interface VehicleJSON {
  dirTag: string,
  heading: string,
  id: string,
  lon: string,
  lat: string,
  predictable: string,
  routeTag: string,
  secsSinceReport: string,
  speedKmHr: string
}

interface VehicleData {
  coordinates: Array<number>,
  properties: object
}

export default Vue.extend({
  name: 'app',
  components: {
    MapContainer,
    FilterContainer
  },
  data () {
    return {
      checkedValues: [],
      vehicleData: []
    }
  },
  async created () {
    this.getvehicleData(true)
    // schedule vehicle data fetching every 3 seconds
    window.setInterval(this.getvehicleData, 3000)
  },
  computed: {
    allRoutes () {
      const allRoutes:Array<string> = []
      for (let i = 0; i < this.vehicleData.length; i++) {
        if(!allRoutes.includes(this.vehicleData[i].properties.routeTag)){
          allRoutes.push(this.vehicleData[i].properties.routeTag)
        }
      }
      return allRoutes.sort()
    }
  },
  methods: {
    async getvehicleData(firstRun:boolean = false) {
      const vehicleRequest = await fetch(`https://cors-anywhere.herokuapp.com/http://webservices.nextbus.com/service/publicJSONFeed?command=vehicleLocations&a=sf-muni&t=${firstRun ? 0 : Date.now() - 15000}`)
      const vehicleJSON = await vehicleRequest.json()
      const currentIds = this.vehicleData.map(d=>d.properties.id)
      for (let i = 0; i < vehicleJSON.vehicle.length; i++) {
        if(!currentIds.includes(vehicleJSON.vehicle[i].id)) {
          this.vehicleData.push(this.getvehicleObject(vehicleJSON.vehicle[i]))
        } else {
          const updatingIndex = this.vehicleData.findIndex((d) => {
            return d.properties.id === vehicleJSON.vehicle[i].id
          })
          this.updatevehicle(vehicleJSON.vehicle[i], updatingIndex)
        }
      }
    },
    getvehicleObject (vehicle:VehicleJSON) {
      return {
        coordinates: [vehicle.lon, vehicle.lat],
        properties: {
          id: vehicle.id,
          routeTag: vehicle.routeTag,
          secsSinceReport: vehicle.secsSinceReport,
          speedKmHr: vehicle.speedKmHr,
          heading: vehicle.heading
        }
      }
    },
    updatevehicle (vehicle:VehicleJSON, updatingIndex:number) {
      Vue.set(this.vehicleData[updatingIndex], 'coordinates', [vehicle.lon, vehicle.lat])
      Vue.set(this.vehicleData[updatingIndex].properties, 'secsSinceReport', vehicle.secsSinceReport)
      Vue.set(this.vehicleData[updatingIndex].properties, 'speedKmHr', vehicle.speedKmHr)
      Vue.set(this.vehicleData[updatingIndex].properties, 'heading', vehicle.heading)
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue